.p{overflow:hidden;}